var map = {
	"./01-m.jpg": "OlgI",
	"./02-m.jpg": "MlFu",
	"./03-m.jpg": "aQqe",
	"./04-m.jpg": "EtNK",
	"./05-m.jpg": "psHA",
	"./06-m.jpg": "KQJu",
	"./07-m.jpg": "CVwm",
	"./08-m.jpg": "jGeF",
	"./09-m.jpg": "5QSQ",
	"./10-m.jpg": "1+c0",
	"./11-m.jpg": "Dhrx",
	"./12-m.jpg": "u7iv",
	"./13-m.jpg": "d2v8",
	"./14-m.jpg": "fO3U",
	"./15-m.jpg": "a7Of",
	"./16-m.jpg": "zosO",
	"./17-m.jpg": "muMd",
	"./18-m.jpg": "eOcC",
	"./19-m.jpg": "7z5+",
	"./20-m.jpg": "XBNR",
	"./21-m.jpg": "HdLW",
	"./22-m.jpg": "kew0",
	"./23-m.jpg": "MJW0",
	"./24-m.jpg": "nMmY",
	"./25-m.jpg": "RE5C",
	"./26-m.jpg": "0Vjx",
	"./27-m.jpg": "wP7n",
	"./28-m.jpg": "qHo6",
	"./29-m.jpg": "+oTf",
	"./30-m.jpg": "+0wG",
	"./31-m.jpg": "asa4",
	"./32-m.jpg": "zqXa",
	"./33-m.jpg": "APX7",
	"./34-m.jpg": "flvd",
	"./35-m.jpg": "YyD8",
	"./36-m.jpg": "WoOq",
	"./37-m.jpg": "SgGY",
	"./38-m.jpg": "SAKm"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1Cu7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects ^\.\/.*\-m\.jpg$
// module id = 1Cu7
// module chunks = 0